<template>
    <InputText class="block w-full" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" ref="input" />
</template>

<script>
    import { defineComponent } from 'vue'
    import InputText from 'primevue/inputtext';

    export default defineComponent({
        components: {
            InputText,
        },
        props: ['modelValue'],
        emits: ['update:modelValue'],
        methods: {
            focus() {
                this.$refs.input.focus()
            }
        }
    })
</script>
